module.exports = __webpack_public_path__ + "img/complete.9812db7a.png";